import React from 'react'
import { Icon, GridRow , Grid, Container ,Menu, MenuItem, GridColumn , Popup } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import "./FooterExt.scss"







export default function footerExt() {

//const history = ();

const aviso = () => {
    
  window.history.go(-1);

};

const reload = () => {
    

  window.location.reload()
};




  return (



<>
<GridColumn centered mobile = {16} className='fetext'  >
<Popup
    content={"Regresar"}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name='arrow alternate circle left' color='red' size='large' onClick={aviso} circular />}
  />      
 
 <Link to = "/Category">
 <Popup
    content={"Categorias"}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name= "sitemap" color='#37fd12'   size='large' circular  />}
  />      
 
 </Link>
 <a href="whatsapp://send?text=  Hola mira esta shop local colaborativa  basada en el contacto directo por WhatsApp %20 https://lacolme.com/">
 <Popup
    content={"Compartir en Whatsap"}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name= "whatsapp" color='#1e5e35'   size='large' circular  />}
  />      
</a>
<Link  to = "/info" > 

<Popup
    content={"Informacion"}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name= "question circle outline" color='#1e5e35'   size='large' circular  />}
  />      

</Link>



<Popup
    content={"Recargar"}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name= "redo" color='#1e5e35'   size='large' circular onClick={reload} />}
  />      







</GridColumn>

</>

  )
}
